import React from "react";
import { useParams, Link } from "react-router-dom";
import "animate.css";

import Navbar from "../Navbar/Navbar";
import MainBodyContainer from "../Common/Body/MainBodyContainer/MainBodyContainer";
import Footer from "../Footer/Footer";
import { EmploymentSupportData } from "../Data/EmploymentSupportData";

import "./EmploymentSupport.css";

const EmploymentSupportPage = () => {
  const { id } = useParams();
  const service = EmploymentSupportData.find((s) => s.id === id);

  if (!service) {
    return (
      <div>
        <Navbar />
        <MainBodyContainer heading={"Service Not Found"}>
          <div className="not-found">
            <h2>Service not found</h2>
            <p>The service you're looking for doesn't exist.</p>
            <Link to="/employment-support" className="back-link">
              ← Back to Employment Support
            </Link>
          </div>
        </MainBodyContainer>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <Navbar />
      <MainBodyContainer heading={service.title}>
        {/* Hero Section */}
        <div className="service-detail-hero">
          <Link to="/employment-support" className="breadcrumb">
            ← Back to Employment Support
          </Link>
          <h1 className="animate__animated animate__fadeInUp">{service.title}</h1>
          <p className="hero-description">{service.description}</p>
          
          {service.successMetrics && (
            <div className="quick-stats">
              {service.successMetrics.interviewsSecured && (
                <div className="quick-stat">
                  <span className="stat-value">{service.successMetrics.interviewsSecured}</span>
                  <span className="stat-label">Interviews Secured</span>
                </div>
              )}
              {service.successMetrics.cvReviews && (
                <div className="quick-stat">
                  <span className="stat-value">{service.successMetrics.cvReviews}</span>
                  <span className="stat-label">CV Reviews</span>
                </div>
              )}
              {service.successMetrics.employmentRate && (
                <div className="quick-stat">
                  <span className="stat-value">{service.successMetrics.employmentRate}</span>
                  <span className="stat-label">Employment Rate</span>
                </div>
              )}
              {service.successMetrics.jobsSecured && (
                <div className="quick-stat">
                  <span className="stat-value">{service.successMetrics.jobsSecured}</span>
                  <span className="stat-label">Jobs Secured</span>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Who This Helps */}
        {service.whoThisHelps && (
          <div className="detail-section">
            <h2 className="section-header">Who This Service Helps</h2>
            <div className="who-helps-grid">
              {service.whoThisHelps.map((who, index) => (
                <div key={index} className="who-helps-item">
                  <span className="check-icon">✓</span>
                  <span>{who}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* What We Offer */}
        {service.whatWeOffer && (
          <div className="detail-section services-offered-section">
            <h2 className="section-header">What We Offer</h2>
            <div className="services-offered-grid">
              {service.whatWeOffer.map((item, index) => (
                <div key={index} className="service-offer-card">
                  <h3 className="offer-name">{item.service}</h3>
                  <p className="offer-description">{item.description}</p>
                  {item.format && <p className="offer-format"><strong>Format:</strong> {item.format}</p>}
                  {item.delivery && <p className="offer-format"><strong>Delivery:</strong> {item.delivery}</p>}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Success Story */}
        {service.successStory && (
          <div className="detail-section success-story-section">
            <h2 className="section-header">Success Story</h2>
            <div className="success-story-card">
              <div className="story-content">
                <h3>{service.successStory.name}</h3>
                <p className="story-background">{service.successStory.background}</p>
                <p className="story-journey">{service.successStory.journey}</p>
                <blockquote className="story-quote">
                  "{service.successStory.quote}"
                </blockquote>
              </div>
            </div>
          </div>
        )}

        {/* Access Info */}
        {service.accessInfo && (
          <div className="detail-section access-section">
            <h2 className="section-header">How to Access This Service</h2>
            <div className="access-grid">
              {service.accessInfo.cost && (
                <div className="access-item">
                  <span className="access-icon">💰</span>
                  <div>
                    <h4>Cost</h4>
                    <p>{service.accessInfo.cost}</p>
                  </div>
                </div>
              )}
              {service.accessInfo.bookingProcess && (
                <div className="access-item">
                  <span className="access-icon">📞</span>
                  <div>
                    <h4>How to Book</h4>
                    <p>{service.accessInfo.bookingProcess}</p>
                  </div>
                </div>
              )}
              {service.accessInfo.languages && (
                <div className="access-item">
                  <span className="access-icon">🌍</span>
                  <div>
                    <h4>Languages</h4>
                    <p>{service.accessInfo.languages}</p>
                  </div>
                </div>
              )}
              {service.accessInfo.location && (
                <div className="access-item">
                  <span className="access-icon">📍</span>
                  <div>
                    <h4>Location</h4>
                    <p>{service.accessInfo.location}</p>
                  </div>
                </div>
              )}
              {service.accessInfo.waitTime && (
                <div className="access-item">
                  <span className="access-icon">⏱️</span>
                  <div>
                    <h4>Wait Time</h4>
                    <p>{service.accessInfo.waitTime}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* CTA */}
        <div className="detail-cta">
          <h2>Ready to Take the Next Step?</h2>
          <p>Contact us to access this service and start your journey to employment.</p>
          <div className="cta-buttons">
            <Link to="/contact" className="cta-button primary">
              Get Support Now
            </Link>
            <Link to="/employment-support" className="cta-button secondary">
              View All Services
            </Link>
          </div>
        </div>
      </MainBodyContainer>
      <Footer />
    </div>
  );
};

export default EmploymentSupportPage;
